var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_setup.isFaqPage)?_c('button',{staticClass:"faq__trigger",on:{"click":function($event){return _setup.faqChat.open()}}},[_c(_setup.AzIcon,{attrs:{"icon-name":"chat","color":"var(--c-white)"}})],1):_vm._e(),_vm._v(" "),_c(_setup.FaqChat,{key:_setup.isFaqPage,ref:"faqChat"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }